export default {
  headerContent: {
    title: 'Sompo Sigorta Doğum (Hamilelik) Sağlık Sigortası Teklifi Hesaplama',
    slogan: "Doğum Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DOĞUM SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Hamilelik ve Doğum Sigortası Nedir?',
    description: {
      title: 'Sompo Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Sompo Sigorta ile ailenize yeni katılacak bebeğin hamilelik dönemini ve doğumunu güvence altına alabilirsiniz. Doğum sigortası, hamilelik sürecinde gerekli olan tedavi masraflarını ve doğum masraflarını karşılayan sigorta ürünüdür. ',
        'Sompo Sigorta doğum sigortasını bekleme süresi olmadan yaptırabilir ve Medicana Sağlık Grubu’ndan hizmet alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Doğum Paketi Teminatları (Kapsamı) Nelerdir?',
      content: [
        {
          paragraph:
            'Sompo Sigorta teminatları anne adayının ihtiyaçlarını karşılamaya yönelik olarak hazırlanmıştır.',
          subList: null
        },
        {
          paragraph: 'Bu Teminatlar;',
          subList: [
            'Yatarak Tedavi',
            'Doğum Teminatı ',
            'Hamilelik Rutin Muayene Teminatı '
          ]
        },
        {
          paragraph: 'Olmak üzere 3 adet teminat bulunmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Yatarak Tedavi;</strong>',
          subList: null
        },
        {
          paragraph: 'Ameliyat, Hastane Yatış, Küçük Müdahale, Yoğun Bakım, Standart Tek Kişilik Özel Oda, Yemek Ve Bir Adet Refakatçi Giderlerini kapsamaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Doğum Teminatı;</strong>',
          subList: null
        },
        {
          paragraph: 'Doğum sırasında gerekli tüm giderleri kapsamaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Hamilelik Rutin Muayene Teminatı;</strong>',
          subList: null
        },
        {
          paragraph: 'Hamilelik döneminde yapılması gereken doktor muayenelerini kapsamaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Doğum Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Doğum Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Doğum Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Doğum Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Doğum Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo Sigorta Doğum Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
